export default __webpack_public_path__ + "images/64eb1d29a46f0a624b7088633b40e80f-environment_small.webp";